import { LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY } from "@faire/web-api/indigofair/settings/LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingOpenWithFaireAvailableForCountry = (): boolean =>
  getSettingValueWithoutAssignment(
    LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY,
    false
  );
